var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOwnerListings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.719,
    height: 33.728,
    viewBox: "0 0 33.719 33.728",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9079"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7831",
    d: "m4.965 25.428 6.477 6.472a9.887 9.887 0 0 0 13.983 0l6.475-6.472a9.9 9.9 0 0 0 0-13.985l-6.475-6.475a9.887 9.887 0 0 0-13.983 0l-6.477 6.475a9.9 9.9 0 0 0 0 13.985zM7.3 13.773 13.772 7.3a6.592 6.592 0 0 1 9.322 0l6.477 6.475a6.6 6.6 0 0 1 0 9.324l-6.477 6.475a6.751 6.751 0 0 1-9.322 0L7.3 23.1a6.6 6.6 0 0 1 0-9.327z",
    transform: "translate(-1.574 -1.572)",
    style: {
      fill: "currentColor",
      stroke: "var(--sidebar-surface)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7832",
    d: "M11.109 22.091a1.509 1.509 0 0 0 1.509-1.509v-3.32h2.113a5.131 5.131 0 1 0 0-10.262h-3.622A1.509 1.509 0 0 0 9.6 8.509v12.073a1.509 1.509 0 0 0 1.509 1.509zm5.736-9.96a2.115 2.115 0 0 1-2.113 2.113h-2.114v-4.226h2.113a2.115 2.115 0 0 1 2.113 2.113z",
    transform: "translate(3.257 2.318)",
    style: {
      fill: "currentColor",
      stroke: "var(--sidebar-surface)"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnerListings);
export default __webpack_public_path__ + "static/media/owner_listings.cbd05b552ca6d7cb9a07739e84b30c3e.svg";
export { ForwardRef as ReactComponent };